import styled from '@emotion/styled';

import colours from '~/utils/colours';
import { Profile, Greet, ProfileEvent, GreetStatus } from '~/types/models';
import { ProfileOrUser } from '~/BonjorosList/util';

export const styledIcon = (
  IconComponent,
  { activeProp, activeColour }
) => styled(IconComponent)`
  font-size: 2em;
  color: ${(props) => (props[activeProp] ? activeColour : colours.grey)};
`;

export function getProfileName(profile: ProfileOrUser) {
  const name = [profile.first_name, profile.last_name].join(' ');

  if (name.trim().length > 0) {
    return name;
  }

  return profile.email;
}

export function getImageProps(
  greet: Greet,
  profile: Profile,
  profileName: string
) {
  if (greet.thumb_url == null) {
    return {
      src: profile.image,
      alt: profileName,
    };
  }

  return {
    src: greet.thumb_url,
    width: 40,
    height: 40,
  };
}

export function getEventText(
  event: ProfileEvent | null,
  status: GreetStatus,
  fallback: string = 'Archived'
) {
  if (!event) {
    return fallback;
  }

  switch (status) {
    case GreetStatus.Error:
      return 'Error';
    default:
      return event.message;
  }
}
